import publicRoutes from '../config/public-routes.json' with {type: 'json'};
import designPreviews from '../config/design-previews.json';
import {HIDDEN_PAYMENT_METHOD_PATHS,PAYMENT_DIRECTORY_PAGES,PAYMENT_METHODS_PATH} from '../src/payment-method-catalog';
import commerce from '../src/commerce-catalog.json' with {type: 'json'};
import {TEAM_ROLES, type TeamRoleId} from '../src/team';

export const TEAM_PAGE_PATH = publicRoutes.teamPath;
const teamRoleSlugs: Readonly<Record<TeamRoleId, string>> = publicRoutes.teamRoleSlugs;

export function teamRolePath(roleId: TeamRoleId): string {
  const slug = teamRoleSlugs[roleId];
  if (!slug) throw new Error(`No public team route exists for ${roleId}`);
  return `${TEAM_PAGE_PATH}/${slug}`;
}

export function teamWorkPath(roleId: TeamRoleId): string {
  return `${teamRolePath(roleId)}/work`;
}

/** Resolve old team links and trailing slashes without changing unknown routes. */
export function resolvePublicPath(path: string): string {
  const withoutTrailingSlash = path.replace(/\/+$/, '') || '/';
  if(HIDDEN_PAYMENT_METHOD_PATHS.includes(withoutTrailingSlash))return `${PAYMENT_METHODS_PATH}/crypto`;
  const publicPages = [...publicRoutes.publicPages, ...Object.values(designPreviews).map(preview => preview.path), ...PAYMENT_DIRECTORY_PAGES.map(page=>page.path), ...commerce.products.flatMap(product =>
    product.id === 'domains' ? [product.publicPath] : [product.publicPath, product.publicPath + '/demo'])];
  if(publicPages.includes(withoutTrailingSlash)) return withoutTrailingSlash;
  const retired: Readonly<Record<string, string>> = publicRoutes.retiredPages;
  if (Object.hasOwn(retired, withoutTrailingSlash)) return retired[withoutTrailingSlash]!;
  if (withoutTrailingSlash === publicRoutes.legacyTeamPath || withoutTrailingSlash === TEAM_PAGE_PATH) return TEAM_PAGE_PATH;
  for (const role of TEAM_ROLES) {
    const rolePath = teamRolePath(role.id);
    const workPath = teamWorkPath(role.id);
    const legacyRolePath = `${publicRoutes.legacyTeamPath}/${role.id}`;
    if (withoutTrailingSlash === legacyRolePath || withoutTrailingSlash === rolePath) return rolePath;
    if (withoutTrailingSlash === `${legacyRolePath}/work` || withoutTrailingSlash === workPath) return workPath;
  }
  return path;
}
